import React, { forwardRef } from 'react';
import { Button } from 'react-bootstrap';

import classNames from 'classnames';
import Icon from '../icon/Icon';

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  iconProps?: {
    isOriginal?: boolean;
  };
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { icon, iconProps = {}, ...restProps } = props;
    return (
      <Button bsPrefix='btn-icon' {...restProps} ref={ref}>
        <Icon
          icon={icon}
          className={classNames({ original: iconProps.isOriginal })}
        />
      </Button>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;
